/**
 * Shared modal styling for Payment Schedule action overlays.
 *
 * Previously these constants lived inline inside `PaymentScheduleDisplay.jsx`
 * (Stripe forms only). Extracting them lets the NMI-track form modals
 * (Update Card, Make a Payment, Restart Plan) match the Stripe variants
 * pixel-for-pixel without re-declaring the same class strings, so the
 * customer never sees a visual diff between processor tracks.
 *
 * Treat this file as a single source of truth — if you change a token here
 * make sure both Stripe and NMI forms still look identical.
 */

import { BRAND_PRIMARY_BTN_CLASS } from '@/constants/brandColors';

export const ACTION_MODAL_CONTENT_CLASS =
  'flex flex-col p-0 gap-0 overflow-hidden bg-[#0b0b10] border-white/10 text-white ' +
  'w-[calc(100vw-1.5rem)] max-w-[calc(100vw-1.5rem)] sm:w-full sm:max-w-md ' +
  'rounded-3xl sm:rounded-3xl ' +
  'max-h-[calc(100dvh-env(safe-area-inset-top)-env(safe-area-inset-bottom)-5.5rem)] sm:max-h-[88vh] ' +
  'shadow-[0_24px_80px_-24px_rgba(0,0,0,0.8)]';

export const ACTION_MODAL_BODY_CLASS =
  'flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-4 sm:px-6 sm:py-5';

export const MODAL_PRIMARY_BTN_CLASS = `h-11 rounded-full text-sm ${BRAND_PRIMARY_BTN_CLASS}`;

export const MODAL_GHOST_BTN_CLASS =
  'h-11 rounded-full text-sm font-medium border border-white/15 bg-white/[0.03] ' +
  'text-white/70 hover:text-white hover:bg-white/[0.08] transition-colors duration-200 ' +
  'disabled:opacity-40 disabled:cursor-not-allowed';
